export default __webpack_public_path__ + "static/amed-sk-6bf20cab2979a4e1b53cca8d12146150.png";